import {MockData} from '../mock-data';
import {
  AgentStateTransition,
  AnsweredCall,
  CallToggled,
  CreateCall,
  Dequeue,
  DisconnectedCall,
  Enqueue, EUAnsweredCall,
  EUCreateCall, EUDisconnectedCall,
  NoConnectCall,
  SkillAdded,
  SkillChanged,
  TransferCall,
  TransferCallAnswered,
  TransferCallEnd,
  CallRetrieved
} from '../../app/services/push-event/push-events';

export class PushEventsMock {

  static getCreateCallPush(login?: string, oname?: string): CreateCall {
    return {
      pushEventType: 'CreateCall',
      session_id: 1234,
      timestamp: new Date().getTime(),
      agent_login: login ? login : MockData.login,
      oname: oname ? oname : MockData.organization,
      sno: '1234',
      cid: 0,
      a_number: '2222',
      g_number: '3333',
      agent_number: login ? login : '47' + MockData.login,
      agent_index: 1,
      agent_dep_id: 0,
      absent_reason: null,
      absent_until: null,
      redir_number: ''
    };
  }

  static getEUCreateCallPush(login?: string, oname?: string): EUCreateCall {
    return {
      login: login ? login : MockData.login,
      session_id: 0,
      dep_id: 0,
      full_number: '12341234',
      peer_number: '12341234',
      trigger_point: 1,
      g_number: '12412423',
      redir_number: '12443',
      expires: 0,
      new_state: 0,
      oname: oname ? oname : MockData.organization,
      timestamp: new Date().getTime(),
      pushEventType: ''
    };
  }

  static getCreateCallPushForOtherAgent(): CreateCall {
    return {
      pushEventType: 'CreateCall',
      session_id: 1234,
      timestamp: new Date().getTime(),
      agent_login: 'not_me',
      oname: MockData.organization,
      sno: '1234',
      cid: 0,
      a_number: '2222',
      g_number: '3333',
      agent_number: '47' + MockData.login,
      agent_index: 1,
      agent_dep_id: 0,
      absent_reason: null,
      absent_until: null,
      redir_number: ''
    };
  }

  static getNoConnectCallPush(): NoConnectCall {
    return {
      pushEventType: 'NoConnectCall',
      session_id: 1234,
      timestamp: new Date().getTime(),
      agent_login: MockData.login,
      oname: MockData.organization,
      sno: '1234',
      cid: 0,
      a_number: '2222',
      g_number: '3333',
      agent_number: '47' + MockData.login,
      agent_index: 1,
      agent_dep_id: 0,
      redir_number: ''
    };
  }

  static getAnsweredCallPush(login?: string, oname?: string): AnsweredCall {
    return {
      pushEventType: 'AnsweredCall',
      oname: oname ? oname : MockData.organization,
      timestamp: new Date().getTime(),
      agent_login: login ? login : MockData.login,
      agent_index: 1,
      agent_number: login ? login : '47' + MockData.login,
      agent_dep_id: 0,
      session_id: 1234,
      sno: '1234',
      cid: 0,
      a_number: '2222',
      g_number: '3333',
      redir_number: ''
    };
  }

  static getEUAnsweredCallPush(): EUAnsweredCall {
    return {
      login: MockData.login,
      session_id: 0,
      dep_id: 0,
      full_number: '12341234',
      peer_number: '12341234',
      trigger_point: 1,
      g_number: '12412423',
      redir_number: '12443',
      expires: 0,
      new_state: 0,
      oname: MockData.organization,
      timestamp: new Date().getTime(),
      pushEventType: ''
    };
  }

  static getTransferCallPush(): TransferCall {
    return {
      pushEventType: 'TransferCall',
      session_id: 1234,
      login: MockData.login,
      timestamp: new Date().getTime(),
      agent_login: MockData.login,
      oname: MockData.organization,
      sno: '1234',
      cid: 0,
      a_number: '2222',
      g_number: '3333',
      agent_number: '47' + MockData.login,
      agent_index: 1,
      agent_dep_id: 0,
      redir_number: '',
      transfer_type: 3,
      transferToNumber: '47' + MockData.login,
    };
  }

  static getTransferCallAnsweredPush(): TransferCallAnswered {
    return {
      pushEventType: 'TransferCallAnswered',
      session_id: 1234,
      login: MockData.login,
      timestamp: new Date().getTime(),
      agent_login: MockData.login,
      oname: MockData.organization,
      sno: '1234',
      cid: 0,
      a_number: '2222',
      g_number: '3333',
      agent_number: '47' + MockData.login,
      agent_index: 1,
      agent_dep_id: 0,
      redir_number: '',
      transfer_type: 3,
      transferToNumber: '47' + MockData.login,
    };
  }

  static getCallToggledPush(): CallToggled {
    return {
      pushEventType: 'CallToggled',
      session_id: 1234,
      timestamp: new Date().getTime(),
      agent_login: MockData.login,
      oname: MockData.organization,
      sno: '1234',
      cid: 0,
      a_number: '2222',
      g_number: '3333',
      agent_number: '47' + MockData.login,
      agent_index: 1,
      agent_dep_id: 0,
      redir_number: '',
      leg1: 'B',
      leg2: 'A',
      status: 0
    };
  }

  static getCallToggledPush2(): CallToggled {
    return {
      pushEventType: 'CallToggled',
      session_id: 1234,
      timestamp: new Date().getTime(),
      agent_login: MockData.login,
      oname: MockData.organization,
      sno: '1234',
      cid: 0,
      a_number: '2222',
      g_number: '3333',
      agent_number: '47' + MockData.login,
      agent_index: 1,
      agent_dep_id: 0,
      redir_number: '',
      leg1: 'B',
      leg2: 'C',
      status: 0
    };
  }

  static getTransferCallEndPush(): TransferCallEnd {
    return {
      pushEventType: 'TransferCallEnd',
      session_id: 1234,
      login: MockData.login,
      timestamp: new Date().getTime(),
      agent_login: MockData.login,
      oname: MockData.organization,
      sno: '1234',
      cid: 0,
      a_number: '2222',
      g_number: '3333',
      agent_number: '47' + MockData.login,
      agent_index: 1,
      agent_dep_id: 0,
      redir_number: '',
      transfer_type: 3,
      transferToNumber: '47' + MockData.login,
    };
  }

  static getRetrieveCallPush(): CallRetrieved {
    return {
      status: 0,
      pushEventType: 'TransferCallEnd',
      session_id: 1234,
      timestamp: new Date().getTime(),
      agent_login: MockData.login,
      oname: MockData.organization,
      sno: '1234',
      cid: 0,
      a_number: '2222',
      g_number: '3333',
      agent_number: '47' + MockData.login,
      agent_index: 1,
      agent_dep_id: 0,
      redir_number: '',
      leg: 0
    };
  }

  static getEnqueuePush(login?: string, oname?: string, sessionId?: number): Enqueue {
    return {
      pushEventType: 'Enqueue',
      session_id: sessionId ? sessionId : Math.floor(Math.random() * 1000),
      creation_time: new Date().getTime(),
      timestamp: new Date().getTime(),
      oname: oname ? oname : MockData.organization,
      fromlogin: login ? login : '222',
      tologin: login ? login : '333',
      ano: '2223433',
      bno: '4770238818',
      gno: '3232323',
      cid: 0
    };
  }

  static getDequeuePush(login?: string, oname?: string, sessionId?: number): Dequeue {
    return {
      pushEventType: 'Dequeue',
      session_id: sessionId ? sessionId : Math.floor(Math.random() * 1000),
      oname: oname ? oname : MockData.organization,
      timestamp: new Date().getTime(),
      bno: '5553232',
      cid: 0,
      ano: '2223433',
      gno: '3232323'
    };
  }

  static getSkillChanged(): SkillChanged {
    return {
      pushEventType: 'SkillChanged',
      oname: 'testorg',
      service_number: '123',
      queue_cid: 0,
      skill_level: 3,
      login: MockData.login,
      no_reply_time: 15,
      wrapup_time: 10,
      deactivated: false,
      timestamp: 0
    };
  }

  static getSkillAdded(): SkillAdded {
    return {
      pushEventType: 'SkillAdded',
      oname: 'testorg',
      service_number: '123',
      queue_cid: 0,
      skill_level: 3,
      login: '789789789',
      no_reply_time: 15,
      wrapup_time: 10,
      deactivated: false,
      timestamp: 0
    };
  }

  static getAgentStateTransition(): AgentStateTransition {
    return {
      pushEventType: 'AgentStateTransition',
      agent_login: MockData.login,
      agent_index: 0,
      agent_number: '1234',
      agent_dep_id: 0,
      oname: MockData.organization,
      timestamp: 0,
      new_state: 0,
      sub_state: 0,
      pending_state: 0
    };
  }

  static getDisconnectedCallPush(login?: string, oname?: string): DisconnectedCall {
    return {
      pushEventType: 'DisconnectedCall',
      session_id: 1234,
      timestamp: new Date().getTime(),
      agent_login: login ? login : MockData.login,
      oname: oname ? oname : MockData.organization,
      sno: '1234',
      cid: 0,
      a_number: '2222',
      g_number: '3333',
      agent_number: login ? login : '47' + MockData.login,
      agent_index: 1,
      agent_dep_id: 0,
      redir_number: ''
    };
  }

  static getEUDisconnectedCallPush(login?: string, oname?: string): EUDisconnectedCall {
    return {
      login: login ? login : MockData.login,
      session_id: 0,
      dep_id: 0,
      full_number: '12341234',
      peer_number: '12341234',
      trigger_point: 1,
      g_number: '12412423',
      redir_number: '12443',
      expires: 0,
      new_state: 0,
      oname: oname ? oname : MockData.organization,
      timestamp: new Date().getTime(),
      pushEventType: ''
    };
  }

}
